'use client';
import { signIn } from 'next-auth/react';
import { XIcon } from '@/components/icons';

export function LoginButton() {
  return (
    <button
      type="button"
      className="login-cta"
      onClick={() => {
        // Report the press for tracked-link visitors (src/app/api/track/press); a beacon survives the navigation.
        try { navigator.sendBeacon('/api/track/press'); } catch {}
        signIn('twitter', { callbackUrl: '/' });
      }}
    >
      <XIcon size={14} />
      Connect
    </button>
  );
}
